import { AsociadoSituacion } from "./asociado-situacion.model"
import { AsociadoTipo } from "./asociado-tipo.model"
import { Associate } from "./associate.model"
import { TipoAportacion } from "./tipoAportacion.model"

export class Aportacion {

  id: number
  asociado: number
  tipo: TipoAportacion
  transaccion: number
  fecha_generacion: string
  fecha_cobro: string
  iban: string
  importe: number
  descripcion: string
  identificador: number
  sepa: string
  anulada: string

  anyo: number;
  derechos: string;
  asociadoListado?: Associate
  tipo_aso: AsociadoTipo
  situacion_aso: AsociadoSituacion

  devolucion: string


  constructor() {
    this.id = 0
    this.asociado = 0
    this.tipo = new TipoAportacion()
    this.transaccion = 0
    this.fecha_generacion = ''
    this.fecha_cobro = ''
    this.iban = ''
    this.importe = 0
    this.descripcion = ''
    this.identificador = 0
    this.sepa = 'S'
    this.anyo = 0
    this.derechos = ''
    this.asociadoListado = undefined
    this.tipo_aso = new AsociadoTipo()
    this.situacion_aso = new AsociadoSituacion()
    this.devolucion = ''
    this.anulada = 'N'
  }

}
